import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionServiceService {

  private sessionKey = 'mySession';

  startSession() {
    if (!sessionStorage.getItem(this.sessionKey)) {
      const uniqueSessionValue = this.generateUniqueSessionValue();
      sessionStorage.setItem(this.sessionKey, uniqueSessionValue);
      console.log('Session started with value:', uniqueSessionValue);
    }
    return sessionStorage.getItem(this.sessionKey);
  }

  removeSession() {
    sessionStorage.removeItem(this.sessionKey);
    console.log('Session removed');
  }

  isSessionActive(): boolean {
    return sessionStorage.getItem(this.sessionKey) !== null;
  }

  private generateUniqueSessionValue(): string {
    return 'session-' + Math.random().toString(36).substr(2, 9);
  }

}
